import { Component } from 'solid-js'
import { VoiceSettingForm } from '../../../../../common/types/texttospeech-schema'
import TextInput from '/web/shared/TextInput'
import Button from '/web/shared/Button'
import { RefreshCw } from 'lucide-solid'
import RangeInput from '/web/shared/RangeInput'
import { i18nStore } from '/web/store'

export const NovelTtsSettings: Component<{
  settings: VoiceSettingForm<'novel'>
  onChange: (value: VoiceSettingForm<'novel'>) => void
}> = (props) => {
  const i18n = i18nStore((s) => ({ t: s.t }))
  const update = (diff: Partial<VoiceSettingForm<'novel'>>) => {
    props.onChange({ ...props.settings, ...diff })
  }

  const generate = () => {
    update({ seed: generateRandomSeed(12) })
  }

  function generateRandomSeed(length: number) {
    const chars = 'abcdefghijklmnopqrstuvwxyz0123456789_'
    return [...Array(length)].map(() => chars[Math.floor(Math.random() * chars.length)]).join('')
  }

  return (
    <>
      <div class="flex items-end">
        <TextInput
          fieldName="novelSeed"
          label={i18n.t.voice_seed}
          helperText={i18n.t.voice_novelSeedHelper}
          value={props.settings.seed ?? ''}
          onChange={(ev) => update({ seed: ev.currentTarget.value })}
        />
        <Button class="ml-2 rounded-lg" onClick={() => generate()}>
          <RefreshCw size={24} />
        </Button>
      </div>

      <RangeInput
        fieldName="novelRate"
        label={i18n.t.voice_playbackRate}
        helperText=""
        min={0.5}
        max={2}
        step={0.01}
        value={props.settings.rate ?? 1}
        onChange={(value) => update({ rate: value })}
      />
    </>
  )
}
